import React from "react"
import * as firebase from "firebase/app"
import "firebase/database"
import { FIREBASE_STATE_KEYS } from "./helpers"
import { NavigationController } from "./NavigationController"
import { FirebaseService } from "./FirebaseService"
import { store } from "../store"
import _ from "../utils/lodashUtils"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import {
  NOTIFY_BACK,
  NOTIFY_BACK_BUTTON,
  PARTNER_ACCEPTED_INVITE,
  DEFAULT_SPACE_NAME,
  NO_BUTTON,
  COMBINE_ORDER_INFO,
  YES_BUTTON,
  COMBINE_ORDER,
  INTERVAL_TIME,
  PARTNER_GO_BACK_FROM_RESTAURANTS,
  CONTINUE,
  OFFLINE,
} from "../constants/messages"
import { FIREBASE_INERNET_CONN_DOWN } from "../constants/notificationMsg"
import { notification, Modal } from "antd"
import history from "../../src/history"
import { throttle, getGenderSpecificMessage } from "../utils/helpers"
import { ORDER_COMBINED_SUCCESS } from "../constants/notificationMsg"
import {
  NOTIFICATION_TYPES,
  ToastMessage,
} from "../components/Notification/Notifications"
import { usePageVisible, usePrevious } from "common-custom-hooks"
import { DeveloperTools } from "../components/DeveloperTools"
import { resetInvite } from "../redux/actionCreators/invitePeople"
import { ActivityIndicator } from "../components/ActivityIndicator"
import { fetchPartnerDetails } from "../redux/actionCreators/invitePeople"
import { emitter } from "../utils/emitter"
import { CUSTOM_EVENTS } from "../constants/commons"
import { CustomModal, TextTag, Button } from "../atoms"
import { SCREENS } from "../constants/screens"

export const FirebaseContext = React.createContext({
  dateState: undefined,
  userState: undefined,
  partnerState: undefined,
  firebaseLoggedInUser: undefined,
})
const throttledNotification = throttle(notification.open, 5000)
const throttleToastMessage = throttle(ToastMessage, 5000)

const FirebaseProvider = (props) => {
  const [dateState, setDateState] = React.useState()
  const [userState, setUserState] = React.useState()
  const [partnerState, setPartnerState] = React.useState()
  const [showDeveloperTools, setShowDeveloperTools] = React.useState(false)
  const [firebaseLoggedInUser, setFirebaseLoggedInUser] = React.useState()
  const [firebaseAuthorisedUser, setFirebaseAuthorisedUser] = React.useState(
    false
  )
  const [isLoadingFirebase, setIsLoadingFirebase] = React.useState(false)
  const [modal, toggleModal] = React.useState(false)
  const [showConfirmOrderModal, setConfirmOrderModal] = React.useState(false)
  const [
    notifyPartnerForBackToPlanningModal,
    setnotifyPartnerForBackToPlanningModal,
  ] = React.useState(false)

  const userId = _.get(store.getState(), "auth.user.uuid")
  const path = FirebaseService.getDefaultPath()
  const dateStatus = props.dateStatus
  const dateStateRef = FirebaseService.getDatabaseRef(path)
  const presenceStateRef = FirebaseService.getDatabaseRef(".info/connected")
  const inviteNotifyPath = `${path}${userId}/notifyInvite`
  const notifyBackPath = `${path}${userId}/notifyBack`
  const notifyCombineOrderPath = `${path}notifyCombineOrder`
  const userStatusDatabaseRef = FirebaseService.getDatabaseRef(
    `${path}${userId}/presence`
  )
  const notifyBackRef = FirebaseService.getDatabaseRef(notifyBackPath)
  const notifyCombineOrderRef = FirebaseService.getDatabaseRef(
    notifyCombineOrderPath
  )
  const backToPlanningPath = `${path}${userId}/${FIREBASE_STATE_KEYS.BACK_TO_PLANNING}`
  const inviteNotifyRef = FirebaseService.getDatabaseRef(inviteNotifyPath)
  const backToPlanningRef = FirebaseService.getDatabaseRef(backToPlanningPath)
  const partnerName = _.get(store.getState(), "auth.partner.display_name")
  const combineOrderModal = () => {
    emitter.fire(CUSTOM_EVENTS.SHOW_COMBINE_ORDER_MODAL, [])
  }

  const partnerGenderPosessive = getGenderSpecificMessage(
    _.get(store.getState(), "auth.partner.gender"),
    "POSSESSIVE"
  )
  const partnerWant = getGenderSpecificMessage(
    _.get(store.getState(), "auth.partner.gender"),
    "WANT"
  )
  const updateLocalDateState = (firebaseSnapshot) => {
    const snapshotValue = firebaseSnapshot.val()
    const userId = _.get(store.getState(), "auth.user.uuid")
    const partnerId = _.get(store.getState(), "auth.partner.uuid")
    const user = _.get(snapshotValue, userId, {})

    let partner = {}
    if (!partnerId && !_.isEmpty(snapshotValue)) {
      const firebaseKeys = Object.keys(snapshotValue)
      firebaseKeys.forEach((key) => {
        if (
          snapshotValue &&
          _.get(snapshotValue[key], "userDetails.username") ===
            _.get(props, "invite.partnerDetails.partner2_identifier")
        ) {
          partner = _.get(snapshotValue, key, {})
        }
      })
    } else {
      partner = _.get(snapshotValue, partnerId, {})
    }
    if (_.get(snapshotValue, "status") === "REJECTED") {
      if (
        snapshotValue.rejectedBy &&
        snapshotValue.rejectedBy !== userId &&
        !modal
      ) {
        history.push("/dashboard")
        Modal.destroyAll()
        setTimeout(function () {
          props.fetchPartnerDetails()
        }, INTERVAL_TIME)
      }
    }
    setDateState(snapshotValue)
    setUserState(user)
    setPartnerState(partner)
  }
  const notifyUser = async ({
    firebaseSnapshot,
    path,
    message,
    onClick = () => {},
  }) => {
    // If value is null, don't do anything.
    const notifyObject = firebaseSnapshot.val()
    if (!notifyObject) {
      return
    }
    throttledNotification({
      message,
      onClick,
      className: "class-cursor",
    })
    //Clear data once notified
    await FirebaseService.delete(path)
  }
  const notifyBackUser = (firebaseSnapshot) => {
    const userId = _.get(store.getState(), "auth.user.uuid")
    let nickName = _.get(store.getState(), "invitePeople.nickName")
    const partnerName = _.get(store.getState(), "auth.partner.display_name")
    const partnerActiveScreen = _.get(
      firebaseSnapshot.val(),
      "partnerActiveScreen"
    )
    notifyUser({
      firebaseSnapshot,
      message: NOTIFY_BACK(partnerName || nickName),
      path: notifyBackPath,
      onClick: () => {
        history.push("/dashboard")
        FirebaseService.patch(
          {
            [FIREBASE_STATE_KEYS.GET_READY]: true,
          },
          `${path}${userId}`
        )
        if (partnerActiveScreen === SCREENS.GET_READY) {
          emitter.fire(CUSTOM_EVENTS.SHOW_READY_PAGE_MODAL, [])
        }
      },
    })
  }
  const notifyCombineOrder = (firebaseSnapshot) => {
    const userToNotify = firebaseSnapshot.val()
    const userId = _.get(store.getState(), "auth.user.uuid")
    const partnerName = _.get(store.getState(), "auth.partner.display_name")
    if (userToNotify === "BOTH") {
      FirebaseService.delete(notifyCombineOrderPath)
      throttleToastMessage({
        type: NOTIFICATION_TYPES.SUCCESS,
        message: ORDER_COMBINED_SUCCESS(partnerName),
      })
    }
  }
  const notifyInvite = (firebaseSnapshot) => {
    const partnerName = _.get(store.getState(), "auth.partner.display_name")
    const nickName =
      _.get(store.getState(), "invitePeople.nickName") ||
      _.get(store.getState(), "invitePeople.partnerDetails.partner2_nickname")
    if (_.get(firebaseSnapshot.val(), "notify")) {
      notifyUser({
        firebaseSnapshot,
        message: PARTNER_ACCEPTED_INVITE(partnerName || nickName),
        path: inviteNotifyPath,
        onClick: () => {
          props.resetInvite()
          history.push("/dashboard")
        },
      })
    }
  }

  const updateOnlinePresenceState = (firebaseSnapshot) => {
    // If we're not currently connected, don't do anything.
    if (firebaseSnapshot.val() === false) {
      return
    }

    // If we are currently connected, then use the 'onDisconnect()'
    // method to add a set which will only trigger once this
    // client has disconnected by closing the app,
    // losing internet, or any other means.
    userStatusDatabaseRef
      .onDisconnect()
      .set({
        [FIREBASE_STATE_KEYS.IS_ONLINE]: false,
        [FIREBASE_STATE_KEYS.LAST_CHANGED]:
          firebase.database.ServerValue.TIMESTAMP,
      })
      .then(function () {
        // The promise returned from .onDisconnect().set() will
        // resolve as soon as the server acknowledges the onDisconnect()
        // request, NOT once we've actually disconnected:

        // We can now safely set ourselves as 'online' knowing that the
        // server will mark us as offline once we lose connection.
        userStatusDatabaseRef.set({
          [FIREBASE_STATE_KEYS.IS_ONLINE]: true,
          [FIREBASE_STATE_KEYS.LAST_CHANGED]:
            firebase.database.ServerValue.TIMESTAMP,
        })
      })
  }

  const isPageVisible = usePageVisible()
  const previousPageVisiblityState = usePrevious(isPageVisible)

  const goBackToPlanning = (firebaseSnapshot) => {
    const userToNotify = firebaseSnapshot.val()
    const userId = _.get(store.getState(), "auth.user.uuid")
    if (userId === userToNotify) {
      emitter.fire(CUSTOM_EVENTS.SHOW_PARTNER_BACK_TO_PLAN_A_DATE_MODAL, [])
    }
  }

  /* Confirm Modal Emitter Registry */
  const toggleConfirmOrderModal = (value) => () => {
    setConfirmOrderModal(value)
  }

  const togglePartnerBackToPlanADateModal = (value) => () => {
    setnotifyPartnerForBackToPlanningModal(value)
  }

  React.useEffect(() => {
    const showModalListener = emitter.addListener(
      CUSTOM_EVENTS.SHOW_COMBINE_ORDER_MODAL,
      toggleConfirmOrderModal(true)
    )
    const hideModalListener = emitter.addListener(
      CUSTOM_EVENTS.HIDE_COMBINE_ORDER_MODAL,
      toggleConfirmOrderModal(false)
    )
    const showPartnerBackToPlanADateListner = emitter.addListener(
      CUSTOM_EVENTS.SHOW_PARTNER_BACK_TO_PLAN_A_DATE_MODAL,
      togglePartnerBackToPlanADateModal(true)
    )
    const hidePartnerBackToPlanADateListner = emitter.addListener(
      CUSTOM_EVENTS.HIDE_PARTNER_BACK_TO_PLAN_A_DATE_MODAL,
      togglePartnerBackToPlanADateModal(false)
    )
    return () => {
      showModalListener.remove()
      hideModalListener.remove()
      showPartnerBackToPlanADateListner.remove()
      hidePartnerBackToPlanADateListner.remove()
    }
  }, [])

  /* for the love of developer tools */
  React.useEffect(() => {
    function handleKeyDownEvent(event) {
      if (event.ctrlKey && event.shiftKey && event.key === "O") {
        setShowDeveloperTools(true)
      }
    }
    window.addEventListener("keydown", handleKeyDownEvent)
    window.addEventListener("offline", () => {
      throttleToastMessage({
        type: NOTIFICATION_TYPES.ERROR,
        message: OFFLINE,
      })
    })
    return () => window.removeEventListener("keydown", handleKeyDownEvent)
  }, [])

  React.useEffect(() => {
    setIsLoadingFirebase(true)
    async function applyFirebaseListeners() {
      if (path !== undefined && firebaseLoggedInUser) {
        try {
          await dateStateRef.once("value", updateLocalDateState)
          await presenceStateRef.on("value", updateOnlinePresenceState)
          await dateStateRef.on("value", updateLocalDateState)
          await notifyBackRef.on("value", notifyBackUser)
          await inviteNotifyRef.on("value", notifyInvite)
          await notifyCombineOrderRef.on("value", notifyCombineOrder)
          await backToPlanningRef.on("value", goBackToPlanning)
        } catch (error) {
          console.error("Unable to set listeners", error)
        }

        setIsLoadingFirebase(false)
      }
    }
    applyFirebaseListeners()
    return () => {
      presenceStateRef.off("value", updateOnlinePresenceState)
      dateStateRef.off("value", updateLocalDateState)
      notifyBackRef.off("value", notifyBackUser)
      notifyCombineOrderRef.off("value", notifyCombineOrder)
      inviteNotifyRef.off("value", notifyInvite)
      backToPlanningRef.off("value", goBackToPlanning)
    }
  }, [path, firebaseLoggedInUser, firebaseAuthorisedUser, dateStatus])

  // authenticated user in firebase, required before trying to read or write anything to firebase.
  // The authentication call fired on login/registration to firebase creates a user if not already present.
  // Due to caching/delay in updation of created user, if we immediately try to read after creating a user
  // that user is not found and permission denied error is thrown.
  // hence we need to only read/write once firebase auth is complete.
  React.useEffect(() => {
    setIsLoadingFirebase(true)
    FirebaseService.AUTH.onAuthStateChanged(
      (user) => {
        setFirebaseLoggedInUser(user)
        setIsLoadingFirebase(false)
      },
      (error) => {
        ToastMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: FIREBASE_INERNET_CONN_DOWN,
          description: error.message,
        })
        setIsLoadingFirebase(false)
      }
    )
  }, [])

  React.useEffect(() => {
    async function checkAuthorisedUser() {
      if (!firebaseAuthorisedUser) {
        try {
          const data = await FirebaseService.read(
            FirebaseService.getDefaultPath()
          )
          if (data) {
            setFirebaseAuthorisedUser(true)
          }
        } catch (error) {
          setFirebaseAuthorisedUser(false)
        }
      }
    }
    checkAuthorisedUser()
  }, [path, firebaseLoggedInUser, dateStatus])
  React.useEffect(() => {
    if (
      isPageVisible !== previousPageVisiblityState &&
      props.offlineOnBackground &&
      firebaseLoggedInUser
    ) {
      FirebaseService.setUserPresence(isPageVisible)
    }
  }, [
    isPageVisible,
    props.offlineOnBackground,
    firebaseLoggedInUser,
    previousPageVisiblityState,
  ])
  return (
    <FirebaseContext.Provider
      value={{
        dateState,
        userState,
        partnerState,
        firebaseLoggedInUser,
      }}
    >
      {isLoadingFirebase &&
      !firebaseAuthorisedUser &&
      path !== undefined &&
      dateStatus !== "INACTIVE" ? (
        <ActivityIndicator global />
      ) : (
        <NavigationController {...props}>{props.children}</NavigationController>
      )}
      <DeveloperTools
        visible={showDeveloperTools}
        closeDeveloperTools={() => setShowDeveloperTools(false)}
      />
      <CustomModal
        title={COMBINE_ORDER(partnerName)}
        visible={showConfirmOrderModal}
        keyboard={false}
        footer={[
          <Button
            onClick={async () => {
              await FirebaseService.setOrderCombined(true)
              await FirebaseService.patch({
                [FIREBASE_STATE_KEYS.NOTIFY_ORDER_COMBINE]: "BOTH",
              })
              throttleToastMessage({
                type: NOTIFICATION_TYPES.SUCCESS,
                message: ORDER_COMBINED_SUCCESS(partnerName),
              })
              emitter.fire(CUSTOM_EVENTS.HIDE_COMBINE_ORDER_MODAL, [])
            }}
          >
            {YES_BUTTON}
          </Button>,
          <Button
            key="cancel"
            btnType="bordered"
            onClick={async () => {
              await FirebaseService.delete(notifyCombineOrderPath)
              FirebaseService.setOrderCombined(false)
              emitter.fire(CUSTOM_EVENTS.HIDE_COMBINE_ORDER_MODAL, [])
            }}
          >
            {NO_BUTTON}
          </Button>,
        ]}
      >
        <TextTag>{COMBINE_ORDER_INFO}</TextTag>
      </CustomModal>
      <CustomModal
        destroyOnClose={true}
        title={PARTNER_GO_BACK_FROM_RESTAURANTS(
          partnerName,
          partnerGenderPosessive,
          partnerWant
        )}
        visible={notifyPartnerForBackToPlanningModal}
        footer={[
          <Button
            onClick={async () => {
              FirebaseService.patch(
                {
                  [FIREBASE_STATE_KEYS.PLAN_A_DATE]: false,
                },
                `${FirebaseService.getDefaultPath()}`
              )
              FirebaseService.setActiveRoute("/plan-new-date")
              history.push("/plan-new-date")
              FirebaseService.delete(backToPlanningPath)
              emitter.fire(
                CUSTOM_EVENTS.HIDE_PARTNER_BACK_TO_PLAN_A_DATE_MODAL,
                []
              )
            }}
          >
            {CONTINUE(partnerName)}
          </Button>,
        ]}
      />
    </FirebaseContext.Provider>
  )
}

const mapStateToProps = (state) => ({
  dateId: _.get(state, "invitePeople.partnerDetails.uuid"),
  dateStatus: _.get(state, "invitePeople.partnerDetails.dating_status"),
  invite: _.get(state, "invitePeople"),
  offlineOnBackground: _.get(state, "developer.offlineOnBackground", true),
})

export default withRouter(
  connect(mapStateToProps, { resetInvite, fetchPartnerDetails })(
    FirebaseProvider
  )
)
